
import { Component, Input, OnInit } from '@angular/core';

interface ValidationError {
  condition: string;
  message: string;
}
@Component({
  selector: 'doc-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
  standalone: false,
})
export class ValidationErrorComponent implements OnInit {
  @Input() controlName: string;
  @Input() form;
  @Input() messages;
  errors: ValidationError[] = [];
  constructor() { }

  ngOnInit(): void {
    for (const key in this.messages) {
      if (this.messages.hasOwnProperty(key)) {
        const message = this.messages[key];
        this.errors.push({ condition: key, message: message });
      }
    }
  }
}
